import { ConfirmSignIn, RequireNewPassword, withAuthenticator } from 'aws-amplify-react';

import 'bootstrap/dist/css/bootstrap.min.css';
import { LoopConfirmSignUp, LoopForgotPassword, LoopSignIn, LoopSignUp, LoopVerifyContact } from './auth';
import { BrandProvider } from './context/BrandProvider';
import AppRouter from './navigation/AppRouter';
import './theme/styles.scss';

const AuthenticatedApp = withAuthenticator(AppRouter, false, [
  <LoopSignIn key="signin" />,
  <ConfirmSignIn key="confirm-signin" />,
  <LoopVerifyContact key="verify-contact" />,
  <LoopSignUp key="signup" />,
  <LoopConfirmSignUp key="confirm-signup" />,
  <LoopForgotPassword key="forgot-password" />,
  <RequireNewPassword key="require-new-password" />,
]);

export default function App() {
  return (
    <BrandProvider>
      <AuthenticatedApp />
    </BrandProvider>
  );
}
